import { ProjectCreationWorkflow } from './project-creation-workflow.model';

/**
 * A synthetic workflow registered in NON-PRODUCTION builds only.
 *
 * WHY THIS EXISTS: the production registry ships empty, which would otherwise make five
 * pass/fail rows across the two exec plans unperformable — backend M2's headline criterion
 * ("…on a program that already has a workflow key set"), QA rows Q1–Q3, the M6 rollback proof,
 * FM7's untyped-tile row and FM12's config row. Worse, FM4's entire contract is overlay-driven
 * transitions, so with a genuinely empty registry NO overlay transition would be reachable in a
 * browser and the plan's "manual transition matrix" could not be executed at all.
 *
 * It deliberately exercises every mechanism the contract supports, so QA against it is meaningful:
 *   - `readOnly` on a field that stays VISIBLE (latitude/longitude) — proves read-only is a
 *     rendering state, not a synonym for hidden
 *   - `providedNull` on `state` — the "does not apply here" case, distinct from `display: false`
 *   - a whole coupled pair hidden (currency + exchangeRate) — removes the Tariff card without
 *     desynchronizing a pair, which is what the FM4 cascade hardening depends on
 *   - `providesProjectType: true` — holds the form at stage one, which is FM7's path
 *
 * It is NOT a preview of VIDA and must not be treated as one; VIDA's real overlay is the VIDA
 * ticket's to write.
 */
export const TEST_WORKFLOW: ProjectCreationWorkflow = {
  key: '__TEST__',
  ruleOverlay: {
    projectType: { readOnly: true },
    latitude: { readOnly: true },
    longitude: { readOnly: true },
    state: { providedNull: true },
    city: { display: false },
    currency: { display: false },
    exchangeRate: { display: false }
  },
  providerOwnedFields: ['projectType', 'state', 'latitude', 'longitude', 'city'],
  providesProjectType: true
};
